module.exports = __webpack_public_path__ + "static/img/lengdongshipin.fbcb647e.png";